import { ResultListMode } from '@aipb/gulliver/catalog/model';
import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { TranslocoModule } from '@jsverse/transloco';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'cat-result-list-mode-toolbar',
  templateUrl: './result-list-mode-toolbar.component.html',
  styleUrls: ['./result-list-mode-toolbar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatIconModule, TranslocoModule]
})
export class ResultListModeToolbarComponent {
  @Input() resultListMode: ResultListMode = 'basic';
  @Input() resultListModes: ResultListMode[] = ['basic', 'basic-compact', 'tile', 'masonry', 'tile-single-column'];
  @Input() enabled = false;

  @Output() changeMode = new EventEmitter<ResultListMode>();

  icons: { [key in ResultListMode]: string } = {
    basic: 'expand',
    'basic-compact': 'compress',
    tile: 'grid_on',
    masonry: 'window',
    'tile-single-column': 'square',
    'masonry-simple': 'window',
    'tile-single-column-simple': 'square'
  };

  isActive(resultListMode: ResultListMode): boolean {
    return this.resultListMode === resultListMode;
  }

  getIcon(key: ResultListMode): string {
    if (key in this.icons) {
      return this.icons[key];
    }

    return 'help_center';
  }
}
